"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abortTimedOutFetch = void 0;
const create_error_1 = require("../create-error");
const error_interfaces_1 = require("../types/error.interfaces");
/**
 * Aborts request's fetch if request times out
 * @param send - raw send
 * @param cancellationMap - cancellation tokens mapped to abort controller
 * @param abortOnTimeout - whether to abort fetch on timeout
 * @returns send
 */
function abortTimedOutFetch(send, cancellationMap, abortOnTimeout) {
    return async (request) => {
        const { cancellationToken } = request;
        const abortController = controllerFromCancellationToken(cancellationToken, cancellationMap) ??
            new AbortController();
        request.signal = abortController.signal;
        try {
            return await send(request);
        }
        catch (error) {
            if (error?.reason === error_interfaces_1.ErrorReason.TimedOut &&
                (abortOnTimeout === undefined || abortOnTimeout)) {
                abortController.abort();
            }
            throw error;
        }
    };
}
exports.abortTimedOutFetch = abortTimedOutFetch;
const controllerFromCancellationToken = (cancellationToken, cancellationMap) => {
    if (cancellationToken) {
        const mappedController = cancellationMap.get(cancellationToken);
        if (!mappedController) {
            throw (0, create_error_1.createError)(error_interfaces_1.ErrorReason.InvalidCancellationToken);
        }
        return mappedController;
    }
    return undefined;
};
